angular.module('aprima-core-ui').factory('PanelConfigurationService', ['LocalStorageRepository', '$log', 'DashboardStructure',
    function (LocalStorageRepository, $log, DashboardStructure) {

        'use strict';

        function getWidgetsForLayout() {
            var selectableWidgets = [];
            var widgets = LocalStorageRepository.getPatientDashboardWidgets();
            var view;

            _.forEach(widgets, function (widget) {
                view = _.cloneDeep(_.find(DashboardStructure.getWidgetViews(), {'id': widget.Id}));
                if (view && view.userPlaceable) {
                    view.Heading = view.displayName;
                    view.Name = view.name;
                    view.TileDescriptorId = view.id;
                    view.Id = view.name + '.template';
                    view.isTemplate = true;
                    view.IsCollapsed = false;
                    selectableWidgets.push(view);
                }
            });

            return selectableWidgets;
        }

        function _getConfiguration(configName, dashboards, type) {
            if(!dashboards){
                dashboards = LocalStorageRepository.getPatientDashboardConfigurations(type || 'all');
            }
            
            var settings = _.find(dashboards, {Id: configName});

            if (!settings) {
                $log.warn('patient dashboard configuration not found');
            }

            return settings;
        }

        function _getLayout(settings, widgetSetName) {

            var widgets, view, pageViews;
            widgets = settings[widgetSetName];
            pageViews = [];

            _.forEach(widgets, function (widget) {
                view = _.find(DashboardStructure.getWidgetViews(), {'id': widget.TileDescriptorId});
                if (view && view.userPlaceable) {
                    var clonedWidget = _.cloneDeep(widget);
                    clonedWidget.view = view.view;
                    clonedWidget.configurationView = view.configurationView;
                    clonedWidget.displayName = view.displayName;
                    pageViews.push(clonedWidget);
                }
            });

            return pageViews;
        }

        function _getLayoutWithConfig(config, widgetSetName, dashboards, type) {
            var settings = _getConfiguration(config, dashboards, type);
            return _getLayout(settings, widgetSetName);
        }

        return {
            getLayoutWithConfig: _getLayoutWithConfig,
            getWidgetsForLayout: getWidgetsForLayout,
        };

    }]);